<template>
  <div>
    <subscription-item
       v-for="(subscriptionGroup, index) in filteredSubscriptions"
       :key="index"
       :index="index"
       :subscriptionGroup="subscriptionGroup"
       :language="language"
       :showAddAdditionalCompanyDialog="showAddAdditionalCompanyDialog"
       :showChangeCreditCardDialog="showChangeCreditCardDialog"
       :showChangeSubscriptionDialog="showChangeSubscriptionDialog"
       :showAddCouponDialog="showAddCouponDialog"
       :showCancelSubscriptionDialog="showCancelSubscriptionDialog"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import SubscriptionItem from './SubscriptionItem.vue';

const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  name: 'SubscriptionList',
  components: {
    SubscriptionItem,
  },
  props: {
    subscriptions: {
      type: Array,
    },
  },
  computed: {
    ...mapUserState([
      'language',
    ]),
    filteredSubscriptions() {
      return this.subscriptions.filter((subscription) => !subscription.is_terminated);
    },
  },
  methods: {
    showAddAdditionalCompanyDialog(payload) {
      this.$eventBus.$emit('show-add-additional-company-dialog', payload);
    },
    showChangeCreditCardDialog(companyId) {
      this.$eventBus.$emit('show-change-credit-card-dialog', companyId);
    },
    showChangeSubscriptionDialog(payload) {
      this.$eventBus.$emit('show-change-subscription-dialog', payload);
    },
    showAddCouponDialog(payload) {
      this.$eventBus.$emit('show-add-coupon-dialog', payload);
    },
    showCancelSubscriptionDialog(payload) {
      this.$eventBus.$emit('show-cancel-subscription-dialog', payload);
    },
  },
};
</script>
